var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/core-js/library/modules/$.cof.js
// module id = 1913
// module chunks = 0